import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connect} from 'react-redux'
import * as StepLabels from '../constants/StepLabels'
import {OUTSOURCING_RECOMMEND, SUMMARY} from '../constants/StepLabels'
import ConfigurationStep from './configuration/ConfigurationStep'
import DomainStep from '../containers/domainstep/DomainStep'
import ClientDataStep from '../containers/clientdata/ClientDataStep'
import PaymentStep from '../containers/payment/PaymentStep'
import SummaryStep from './summary/SummaryStep'
import StepSelection from '../containers/StepSelection'
import Column, * as ColumnSizes from '../components/Column'
import ColumnWrapper from '../components/ColumnWrapper'
import AppPreloader from '../components/AppPreloader'
import {TransitionGroup} from 'react-transition-group'
import ScrollToTop from '../components/ScrollToTop'
import StepWrapper from '../components/StepWrapper'
import {getLabeledStepOrder, getStepOrder} from '../selectors/UserInterface'
import StickyColumn from '../containers/StickyColumn'
import MediaQuery from 'react-responsive'
import {Power1, TweenLite} from "gsap";
import {initializeAppWithCart} from "../actions/AppInit.WithCart";
import {initializeAppWithPreset} from "../actions/AppInit.WithPreset";
import {initializeApp} from "../actions/AppInit.Regular";
import {gotoNextStep, gotoPrevStep} from "../actions/StepControl";
import {APP_MODE_ACCESSORY, APP_MODE_AGENCYSERVER_ADD_PROJECT, APP_MODE_AUTHENTICATED_ORDER, APP_MODE_OUTSOURCING, APP_MODE_PRODUCT_CHANGE} from "../constants/General";
import {initializeAppOutsourcing} from "../actions/AppInit.Outsourcing";
import OutsourcingTargetStep from "./outsourcing/OutsourcingTargetStep";
import OutsourcingRecommendStep from "./outsourcing/OutsourcingRecommendStep";
import {initializeAppAuthenticatedOrder} from "../actions/AppInit.AuthenticatedOrder";
import ProductSelectionStep from "./productselection/ProductSelectionStep";
import {isBaseArticleDataLoaded} from "../selectors/ProductSelection";
import {initializeAppProductChange} from "../actions/AppInit.ProductChange";
import ProductChangeStep from "./productselection/ProductChangeStep";
import {initializeAppAccessory} from "../actions/AppInit.Accessory";
import {initializeAppAddProject} from "../actions/AppInit.AddProject";

class App extends Component {

    constructor(props) {
        super(props)

        this.state = {
            showScrollToTop: false
        }

    }

    static propTypes = {
        baseArticleId: PropTypes.any,
        baseAddon: PropTypes.string,
        initialCartId: PropTypes.string,
        initParams: PropTypes.object,
        currentStep: PropTypes.any.isRequired,
        appInitialized: PropTypes.bool,
        labeledStepOrder: PropTypes.object.isRequired
    }

    static defaultProps = {
        initialArticles: [],
        initialPromotionCode: ''
    }

    static get SCROLL_DURATION() {
        return Math.min(Math.max(0.35, (window.scrollY - 140) / 700), 0.75)
    }

    componentDidMount() {

        if (this.props.initialCartId) {

            this.props.initializeAppWithCart(this.props.baseArticleId, this.props.initialCartId, this.props.initParams)

        } else if (this.props.initParams && this.props.initParams.createdFromPreset) {
            this.props.initializeAppWithPreset(this.props.baseArticleId, this.props.initParams)

        } else if (this.props.baseArticleId) {

            this.props.initializeApp(this.props.baseArticleId, this.props.initParams)

        } else if (this.props.mode === APP_MODE_OUTSOURCING) {

            this.props.initializeAppOutsourcing(this.props.initParams);

        } else if (this.props.mode === APP_MODE_AUTHENTICATED_ORDER) {

            this.props.initializeAppAuthenticatedOrder(this.props.initParams);

        } else if (this.props.mode === APP_MODE_PRODUCT_CHANGE) {

            this.props.initializeAppProductChange(this.props.initParams);

        } else if (this.props.mode === APP_MODE_ACCESSORY) {

            this.props.initializeAppAccessory(this.props.initParams);
            
        } else if (this.props.mode === APP_MODE_AGENCYSERVER_ADD_PROJECT) {

            this.props.initializeAppAddProject(this.props.initParams);

        }

        window.addEventListener('scroll', this.handleScroll)

    }

    shouldComponentUpdate(nextProps, nextState) {

        if (nextProps.currentStep !== this.props.currentStep) {
            return true
        }

        if (nextProps.appInitialized !== this.props.appInitialized) {
            return true
        }

        if (nextProps.mapStepsToLabel !== this.props.labeledStepOrder) {
            return true
        }

        if (nextProps.orderComplete !== this.props.orderComplete) {
            return true
        }

        if (nextProps.isAuthenticatedUser !== this.props.isAuthenticatedUser) {
            return true
        }

        if (nextProps.existingCustomerSelected !== this.props.existingCustomerSelected) {
            return true
        }

        if (nextProps.baseAddon !== this.props.baseAddon) {
            return true
        }

        if (nextProps.baseArticleId !== this.props.baseArticleId) {
            return true
        }

        return false
    }

    handleScroll = (e) => {

        if (window.scrollY > 500) {
            this.setState(
                {showScrollToTop: true}
            )
        } else {
            this.setState(
                {showScrollToTop: false}
            )
        }

    }

    scrollToTop = (e) => {

        window.removeEventListener('scroll', this.handleScroll)
        TweenLite.to(window, App.SCROLL_DURATION, {
            scrollTo: {y: 0}, ease: Power1.easeInOut, complete: () => {
                window.addEventListener('scroll', this.handleScroll)
            }
        })
        this.setState(
            {showScrollToTop: false}
        )

    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll)
    }

    getNextLabel = (stepKey) => {

        const index = this.props.stepOrder.indexOf(stepKey);

        const keys = Object.keys(this.props.labeledStepOrder)

        if (index > keys.length - 2) {
            return ""
        }

        return this.props.labeledStepOrder[keys[index + 1]].title;

    }

    getPrevLabel = (stepKey) => {

        const index = this.props.stepOrder.indexOf(stepKey);

        if (index === 0) {
            return this.props.baseAddon ? "Zurück zur Tarifauswahl" : "";
        }

        return this.props.labeledStepOrder[Object.keys(this.props.labeledStepOrder)[index - 1]].title;

    }

    render() {

        let stepToRender = null

        const {currentStep, appInitialized} = this.props;

        if (!appInitialized || !currentStep) {
            return (
                <AppPreloader label=""/>
            )
        }

        switch (currentStep) {

            case StepLabels.PRODUCT_CHANGE:
                stepToRender = <ProductChangeStep
                    key={currentStep}
                    stepLabel={currentStep}
                    prevLabel={this.getPrevLabel(currentStep)}
                    nextLabel={this.getNextLabel(currentStep)}
                    onButtonNextClick={this.props.onStepControlNext}
                    onButtonPrevClick={this.props.onStepControlPrev}
                />
                break

            case StepLabels.PRODUCT_SELECTION:
                stepToRender = <ProductSelectionStep
                    key={currentStep}
                    stepLabel={currentStep}
                    prevLabel={this.getPrevLabel(currentStep)}
                    nextLabel={this.getNextLabel(currentStep)}
                    onButtonNextClick={this.props.onStepControlNext}
                    onButtonPrevClick={this.props.onStepControlPrev}
                />
                break

            case StepLabels.OUTSOURCING_RECOMMEND:
                stepToRender = <OutsourcingRecommendStep
                    key={currentStep}
                    stepLabel={currentStep}
                    prevLabel={this.getPrevLabel(currentStep)}
                    nextLabel="Empfehlung versenden"
                    onButtonNextClick={this.props.onStepControlNext}
                    onButtonPrevClick={this.props.onStepControlPrev}
                />
                break

            case StepLabels.OUTSOURCING_TARGET:
                stepToRender = <OutsourcingTargetStep
                    key={currentStep}
                    stepLabel={currentStep}
                    prevLabel={this.getPrevLabel(currentStep)}
                    nextLabel={this.getNextLabel(currentStep)}
                    onButtonNextClick={this.props.onStepControlNext}
                    onButtonPrevClick={this.props.onStepControlPrev}
                />
                break

            case StepLabels.CONFIG:
                stepToRender = <ConfigurationStep
                    key={currentStep}
                    stepLabel={currentStep}
                    prevLabel={this.getPrevLabel(currentStep)}
                    nextLabel={this.getNextLabel(currentStep)}
                    onButtonNextClick={this.props.onStepControlNext}
                    onButtonPrevClick={this.props.onStepControlPrev}
                />
                break

            case StepLabels.DOMAIN:
                stepToRender = <DomainStep
                    key={currentStep}
                    stepLabel={currentStep}
                    prevLabel={this.getPrevLabel(currentStep)}
                    nextLabel={this.getNextLabel(currentStep)}
                    onButtonNextClick={this.props.onStepControlNext}
                    onButtonPrevClick={this.props.onStepControlPrev}
                />
                break

            case StepLabels.CLIENTDATA:
                stepToRender = <ClientDataStep
                    key={currentStep}
                    stepLabel={currentStep}
                    prevLabel={this.getPrevLabel(currentStep)}
                    nextLabel={this.getNextLabel(currentStep)}
                    onButtonNextClick={this.props.onStepControlNext}
                    onButtonPrevClick={this.props.onStepControlPrev}
                />
                break

            case StepLabels.PAYMENT:
                stepToRender = <PaymentStep
                    key={currentStep}
                    stepLabel={currentStep}
                    prevLabel={this.getPrevLabel(currentStep)}
                    nextLabel={this.getNextLabel(currentStep)}
                    onButtonNextClick={this.props.onStepControlNext}
                    onButtonPrevClick={this.props.onStepControlPrev}
                />
                break

            case StepLabels.SUMMARY:
                stepToRender = <SummaryStep
                    key={currentStep}
                    stepLabel={currentStep}
                    prevLabel={this.getPrevLabel(currentStep)}
                    onButtonNextClick={this.props.onStepControlNext}
                    onButtonPrevClick={this.props.onStepControlPrev}
                />
                break

            default:
                stepToRender = null
                break

        }

        const renderStepSelection = this.props.stepOrder.length > 1;

        return (
            <MediaQuery maxWidth={1023}>
                {(isMatching) => {
                    if (!isMatching) {
                        return (
                            <TransitionGroup component={ColumnWrapper}>
                                {this.state.showScrollToTop ? <ScrollToTop onClick={this.scrollToTop}/> : null}
                                <Column columnWidth={ColumnSizes.SIZE_66}>
                                    {renderStepSelection ? <StepSelection stepConfig={this.props.labeledStepOrder} stepOrder={this.props.stepOrder}/> : null}
                                    <TransitionGroup component="div" className="step-display">
                                        <StepWrapper key={this.props.currentStep} blockMouse={this.props.orderComplete}>
                                            {stepToRender}
                                        </StepWrapper>
                                    </TransitionGroup>
                                </Column>
                                {this.props.currentStep !== SUMMARY && this.props.currentStep !== OUTSOURCING_RECOMMEND ?
                                    <StickyColumn columnWidth={ColumnSizes.SIZE_33}/> : null}
                            </TransitionGroup>
                        )
                    } else {
                        return (
                            <Column>
                                {renderStepSelection ? <StepSelection stepConfig={this.props.labeledStepOrder} stepOrder={this.props.stepOrder}/> : null}
                                <TransitionGroup component="div" className="step-display">
                                    <StepWrapper key={this.props.currentStep} blockMouse={this.props.orderComplete}>
                                        {stepToRender}
                                    </StepWrapper>
                                </TransitionGroup>
                            </Column>
                        )
                    }
                }}
            </MediaQuery>
        )
    }
}

const mapStateToProps = (state, ownProps) => {

    return {
        currentStep: state.ui.currentStep,
        appInitialized: state.appState.isInitialized,
        labeledStepOrder: getLabeledStepOrder(state),
        stepOrder: getStepOrder(state),
        orderComplete: state.appState.orderComplete,
        isAuthenticatedUser: state.clientDataStep.clientData !== false,
        existingCustomerSelected: state.clientDataStep.existingCustomerSelected,
        mode: state.appState.mode,
        baseArticleDataLoaded: isBaseArticleDataLoaded(state),
    }

}

const mapDispatchToProps = (dispatch) => {

    return {
        initializeApp: (baseArticleId, initParams) => {
            dispatch(initializeApp(baseArticleId, initParams))
        },
        initializeAppWithCart: (baseArticleId, cartId, initParams) => {
            dispatch(initializeAppWithCart(baseArticleId, cartId, initParams))
        },
        initializeAppWithPreset: (baseArticleId, presetId) => {
            dispatch(initializeAppWithPreset(baseArticleId, presetId))
        },
        initializeAppOutsourcing: (initParams) => {
            dispatch(initializeAppOutsourcing(initParams))
        },
        initializeAppAuthenticatedOrder: (initParams) => {
            dispatch(initializeAppAuthenticatedOrder(initParams))
        },
        initializeAppProductChange: (initParams) => {
            dispatch(initializeAppProductChange(initParams))
        },
        initializeAppAddProject: (initParams) => {
            dispatch(initializeAppAddProject(initParams))
        },
        initializeAppAccessory: (initParams) => {
            dispatch(initializeAppAccessory(initParams))
        },
        onStepControlNext: () => {
            dispatch(gotoNextStep())
        },
        onStepControlPrev: () => {
            dispatch(gotoPrevStep())
        }
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(App)



/** WEBPACK FOOTER **
 ** ./src/containers/App.js
 **/